module.exports.EMBEDDING_SDK_PACKAGE_UNKNOWN_VERSION = "unknown";
module.exports.EMBEDDING_SDK_BUNDLE_UNKNOWN_VERSION = "vUNKNOWN";
